export default "__VITE_ASSET__144a69cb__"